
import { ApprovalApiClient } from "@/clients/approvalApiClient";
import { Invoice } from "@/types/payments";

export class ApprovalService {
  private apiClient: ApprovalApiClient;

  constructor() {
    this.apiClient = new ApprovalApiClient();
  }

  async getUnapprovedInvoices(): Promise<Invoice[]> {
    try {
      console.log("ApprovalService: Fetching unapproved invoices");
      return this.apiClient.getUnapprovedInvoices();
    } catch (error) {
      console.error("Error fetching unapproved invoices:", error);
      throw error;
    }
  }

  async getApprovedInvoices(): Promise<Invoice[]> {
    try {
      console.log("ApprovalService: Fetching approved invoices");
      return this.apiClient.getApprovedInvoices();
    } catch (error) {
      console.error("Error fetching approved invoices:", error);
      throw error;
    }
  }

  async approveInvoice(invoiceId: string): Promise<{ success: boolean; invoice?: Invoice }> {
    try {
      // Get the user ID from the auth context - in a real app this would use the auth context
      // Currently using supabase.auth.getUser() directly in the client
      return this.apiClient.approveInvoice(invoiceId, "current-user-id");
    } catch (error) {
      console.error("Error approving invoice:", error);
      return { success: false };
    }
  }
}
